// Random "goo blob" loaders — a slick, compact replacement for the two-dot loader. Every loader
// slot (.generating-spinner, .spinner-border, the insights/analytics/import spinners…) gets ONE of
// three SMIL-animated blob SVGs at random, drawn in `currentColor` so it stays high-contrast: white
// on the dark overlays, black on light surfaces — inheriting the exact colour the two-dot retrofit
// already resolves. The white background + fixed #111 fill from the source files are stripped, and
// each goo filter gets a unique id so multiple loaders on one page don't collide.
(function () {
  // Compact defs: the r-animation `values` are shared by every circle in a loader; each circle only
  // varies cx / cy / begin. goo = feGaussianBlur stdDeviation (0 → no gooey merge, plain dots).
  var LOADERS = [
    { vb: '-70 -70 316.1 316.1', dur: 2.336, goo: 8.81,
      v: '20.02;23.93;27.68;31.14;34.18;36.67;38.52;39.66;40.04;39.66;38.52;36.67;34.18;31.14;27.68;23.93;20.02;16.11;12.36;8.90;5.86;3.37;1.52;0.38;0.00;0.38;1.52;3.37;5.86;8.90;12.36;16.11;20.02',
      c: [[0,0,-0.149],[88,0,-2.153],[176,0,-0.471],[0,88,-1.832],[88,88,0],[176,88,-1.190],[0,176,-2.164],[88,176,-1.511],[176,176,-1.843],[44,44,-1.644],[132,44,-1.965],[44,132,-1.323],[132,132,-1.002]] },
    // goo 8.94, not 0: a 0 disables the feGaussianBlur merge, so this variant rendered as plain
    // unmerged DOTS. Because the variant is picked at RANDOM per loader, one retrofit in three
    // came out as dots — 'the dots are pretty much everywhere', and the preview cover appearing
    // to "click" from blob to dots when a second loader re-rolled. Matches gooey's GooLoader.
    { vb: '-74.4 -74.4 324.9 324.9', dur: 1.808, goo: 8.94,
      v: '23.78;27.81;31.68;35.26;38.39;40.96;42.87;44.04;44.44;44.04;42.87;40.96;38.39;35.26;31.68;27.81;23.78;19.74;15.87;12.29;9.16;6.59;4.68;3.51;3.11;3.51;4.68;6.59;9.16;12.29;15.87;19.74;23.78',
      c: [[0,0,-1.302],[88,0,-0.921],[176,0,-1.302],[0,88,-0.921],[88,88,0],[176,88,-0.921],[0,176,-1.302],[88,176,-0.921],[176,176,-1.302],[44,44,-0.651],[132,44,-0.651],[44,132,-0.651],[132,132,-0.651]] },
    { vb: '-68.7 -68.7 313.4 313.4', dur: 2.336, goo: 8.52,
      v: '19.75;23.45;27.01;30.29;33.16;35.52;37.28;38.36;38.72;38.36;37.28;35.52;33.16;30.29;27.01;23.45;19.75;16.05;12.49;9.21;6.33;3.97;2.22;1.14;0.77;1.14;2.22;3.97;6.33;9.21;12.49;16.05;19.75',
      c: [[0,0,-0.361],[88,0,-1.730],[176,0,-2.113],[0,88,-2.314],[88,88,0],[176,88,1.190],[0,176,-0.945],[88,176,-0.562],[176,176,0.806],[44,44,-1.203],[132,44,-0.619],[44,132,-1.787],[132,132,-0.035]] }
  ];

  var uid = 0;
  function svgFor(L) {
    // POSTER FRAME: the static `r` painted before SMIL starts. Authored at v[0] the circles are too
    // far apart for the goo blur to merge, so that frame is a grid of separate DOTS — a visible flash
    // of a different-looking component. Start at the PEAK radius so it is already a merged blob.
    // (Same fix as gooey's GooLoader.jsx, which was ported from this file — keep the two in step.)
    var r0 = Math.max.apply(null, L.v.split(';').map(Number));
    var circles = L.c.map(function (c) {
      return '<circle cx="' + c[0] + '" cy="' + c[1] + '" r="' + r0 + '" fill="currentColor">' +
        '<animate attributeName="r" values="' + L.v + '" dur="' + L.dur + 's" begin="' + c[2] + 's" repeatCount="indefinite" calcMode="linear"/></circle>';
    }).join('');
    var defs = '', gOpen = '<g>';
    if (L.goo) {
      var id = 'goo' + (++uid);
      defs = '<defs><filter id="' + id + '" x="-50%" y="-50%" width="200%" height="200%" color-interpolation-filters="sRGB">' +
        '<feGaussianBlur in="SourceGraphic" stdDeviation="' + L.goo + '"/>' +
        '<feColorMatrix mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 20 -9"/></filter></defs>';
      gOpen = '<g filter="url(#' + id + ')">';
    }
    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="' + L.vb + '" width="100%" height="100%" aria-hidden="true" focusable="false">' +
      defs + gOpen + circles + '</g></svg>';
  }

  // The universal two-dot retrofit slots (see style.css "Universal two-dot loader retrofit").
  // .app-loader-nav = the loudlink "stretching nav dots" (its two-dot spans are CHILDREN, so
  // overwriting innerHTML swaps them for the blob). The rest are the pseudo-element retrofit classes.
  var SEL = '.app-loader-nav,.generating-spinner,.analytics-loading-spinner,.insights-loading-spinner,.import-modal-progress-spinner,.spinner-border:not(.spinner-border-sm)';
  // Full-bleed preview overlays draw their loader with ::before/::after pseudo-dots (nothing to
  // fill), so they're handled separately (append a floated blob) rather than by overwriting
  // innerHTML — overwriting would destroy the overlay's own content.
  var OVSEL = '.sidebar-preview-loading-overlay,.sidebar-preview-transition-overlay,.ve-open-gate-cover';
  // ONE loader site-wide (James): every loader slot renders loader_1 — the FIRST blob — instead of a
  // random pick of three, so nothing differs in shape from one loader to the next (sizes still vary by
  // context via CSS). Kept as a function so callers are unchanged; swap the index to re-point the app.
  var LOADER_INDEX = 0;
  function rndSvg() { return svgFor(LOADERS[LOADER_INDEX]); }
  function apply(el) {
    if (!el.classList || el.classList.contains('has-goo-loader')) return;
    el.classList.add('has-goo-loader');
    el.innerHTML = rndSvg();
  }
  // NOTE the different marker class. These targets are full-bleed overlays, not spinner slots,
  // and `.has-goo-loader` carries `width/height: 26px !important` — tagging an overlay with it
  // COLLAPSED the whole black cover to a 26px square in the top-left corner (measured: a 420x760
  // container's overlay rendered 26x26 at 0,0), so it stopped covering anything and dragged its
  // loader into the corner with it. `.has-goo-float` gets the pseudo-dot suppression without the
  // sizing.
  function applyOverlay(el) {
    if (!el.classList || el.classList.contains('has-goo-float')) return;
    el.classList.add('has-goo-float');
    var s = document.createElement('span');
    s.className = 'goo-loader-float';
    s.innerHTML = rndSvg();
    el.appendChild(s); // centred over the overlay; the two-dot loaders are hidden via CSS
  }
  function scan(root) {
    if (!root || root.nodeType !== 1) return;
    if (root.matches) { if (root.matches(SEL)) apply(root); if (root.matches(OVSEL)) applyOverlay(root); }
    if (root.querySelectorAll) { root.querySelectorAll(SEL).forEach(apply); root.querySelectorAll(OVSEL).forEach(applyOverlay); }
  }
  scan(document.body || document.documentElement);
  document.addEventListener('DOMContentLoaded', function () { scan(document.body); });
  // Loaders are almost always injected on demand — catch them as they appear.
  try {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var n = muts[i].addedNodes;
        for (var j = 0; j < n.length; j++) scan(n[j]);
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  } catch (_) {}
})();
